export default __webpack_public_path__ + "static/media/Idle (1).949f11e1.png";